import { useEffect, useState } from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { NonDismissibleDialog } from '@scoir/modals'
import window from 'browser-lib/window'

const { Body, Footer } = NonDismissibleDialog

interface PDFProps {
  bytes?: ArrayBuffer
  pdfTitle: string
}

const useStyles = makeStyles(() => ({
  downloadButton: {
    '&:focus': {
      color: 'white',
    },
  },
}))

const PDFDocumentViewerModalContent = ({ bytes, pdfTitle }: PDFProps) => {
  const { downloadButton } = useStyles()
  const [blobUrl, setBlobUrl] = useState('')
  useEffect(() => {
    if (bytes) {
      const blob = new Blob([bytes], { type: 'application/pdf' })
      setBlobUrl(window.URL.createObjectURL(blob))
    }
  }, [bytes])
  useEffect(() => {
    return () => {
      if (blobUrl) {
        window.URL.revokeObjectURL(blobUrl)
      }
    }
  }, [blobUrl])
  return (
    <>
      <Body>
        {blobUrl && (
          <Box height={600}>
            <object
              data={blobUrl}
              title={pdfTitle}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>
                This browser does not support inline PDFs. Please download the PDF to view it:{' '}
                <a href={blobUrl}>Download PDF</a>
              </p>
            </object>
          </Box>
        )}
      </Body>
      <Footer>
        <Footer.CloseButton>Cancel</Footer.CloseButton>
        {blobUrl && (
          <Footer.PrimaryActionButton
            // @ts-expect-error no target typing
            target="_blank"
            className={downloadButton}
            href={blobUrl}
          >
            Open
          </Footer.PrimaryActionButton>
        )}
      </Footer>
    </>
  )
}
interface PDFModalProps extends PDFProps {
  pdfTitle: string
  open: boolean
  onCancel: () => void
  showScrim?: boolean
}

const PDFDocumentViewerModal = ({ open, onCancel, pdfTitle, showScrim, ...rest }: PDFModalProps) => (
  <NonDismissibleDialog
    open={open}
    onClose={onCancel}
    scroll="paper"
    hideBackdrop={!showScrim}
    headerText={pdfTitle}
  >
    <PDFDocumentViewerModalContent
      pdfTitle={pdfTitle}
      {...rest}
    />
  </NonDismissibleDialog>
)
export default PDFDocumentViewerModal
